import { useQuery } from "@tanstack/react-query";
import { ReconciliationService } from "@/api";
import type { reconciliation_InvoiceCorrectionListResponse } from "@/api";

// invoiceCorrectionKeys namespaces the TanStack Query cache for invoice-level
// corrections (rows in `invoice_overrides`) that belong to a debtor account.
// These are READ-ONLY here: they are created/edited on the invoice itself
// ("Correct this invoice" / "Correct subsidy share"), and only surfaced on the
// debtor (and subsidy) account so the operator can see them alongside extras
// and account corrections, sortable by date.
export const invoiceCorrectionKeys = {
  all: ["reconciliation", "invoice-corrections"] as const,
  listByDebtor: (debtorId: string) =>
    [...invoiceCorrectionKeys.all, "by-debtor", debtorId] as const,
};

export function useDebtorInvoiceCorrections(debtorId: string | null) {
  return useQuery<reconciliation_InvoiceCorrectionListResponse>({
    queryKey: debtorId
      ? invoiceCorrectionKeys.listByDebtor(debtorId)
      : [...invoiceCorrectionKeys.all, "none"],
    queryFn: () =>
      ReconciliationService.getApiV1ReconciliationDebtorAccountsInvoiceCorrections(
        debtorId as string,
      ),
    enabled: !!debtorId,
  });
}
